import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=4ebb8acc&scoped=true&"
import script from "./OrderListItem.vue?vue&type=script&lang=js&"
export * from "./OrderListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=4ebb8acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb8acc",
  null
  
)

export default component.exports